import cn from 'classnames';
import { useContext } from 'react';

import { BrandContext } from 'context/BrandContext';

const Subheading = ({ brandStylesOverrides = '', className = '', children }) => {
  const { brand } = useContext(BrandContext);

  return (
    <h2
      className={cn(className, brand, {
        h6: !brandStylesOverrides,
        [brandStylesOverrides]: brandStylesOverrides,
      })}
    >
      {children}
    </h2>
  );
};

Subheading.propTypes = {
  className: PropTypes.string,
  brandStylesOverrides: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default Subheading;
